import { anyPass, apply, concat, equals, filter, intersection, isNil, keys, map, omit, pipe } from 'rambda'
import formDiff from './formDiff'

export default (original, incoming) => pipe(
  formDiff,
  omitKeys([original, incoming]),
)(original, incoming)

const omitKeys = pipe(
  filter(Boolean),
  map(pipe(
    filter(anyPass([isNil, equals(0)])),
    keys,
  )),
  apply(intersection),
  concat(['isRefurbished', 'price', 'reviewsExternal']),
  omit,
)
